import { render } from "./UserIdentificationScreen.vue?vue&type=template&id=6d8a75d6&scoped=true"
import script from "./UserIdentificationScreen.vue?vue&type=script&lang=js"
export * from "./UserIdentificationScreen.vue?vue&type=script&lang=js"

import "./UserIdentificationScreen.vue?vue&type=style&index=0&id=6d8a75d6&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8a75d6"]])

export default __exports__